<template>
  <main class="layoutIcons" :style="{ height: contentHeight }">
    <section
      v-if="iamKey && iamSecret"
      ref="layoutCams"
      class="layoutIcons-scroll"
    >
      <section class="layoutIcons-layout">
        <h4 class="layoutIcons-layout_title">表示しているカメラ</h4>

        <draggable
          class="layoutIcons-layers"
          :class="{
            ['layoutIcons-layers--text']: !displayThumbnail,
            ['layoutIcons-layers--video']: displayThumbnail,
          }"
          :list="initLayers"
          group="layout-cams"
          handle=".icon-drag_drop"
          :move="handleMove"
          @end="handleDragEnd"
        >
          <div
            v-for="(cam, index) in initLayers"
            :id="`cam-id-${cam.id}`"
            :key="index"
            class="layoutIcons-layer"
          >
            <video-stream
              v-if="displayThumbnail"
              :id="initLayers[index].id"
              :ref="`display-layer${index}`"
              :key="`main-cam${index}`"
              :stream-config="{
                accessKeyId: iamKey,
                secretAccessKey: iamSecret,
                streamName: initLayers[index].kvsVideoStreamName,
                region: initLayers[index].awsRegionName,
                autoplay: true,
              }"
              :title="initLayers[index].name"
              main
              :disable-zoom="true"
              zoomout-on-restore
              show-skeleton
              controller-size="small"
              :show-controllers="false"
              :hide-display-controller="true"
            />
            <h5>
              <span class="icon icon-drag_drop"></span>
              <span class="layoutIcons-layer_title">{{ cam.name }}</span>
            </h5>

            <v-tooltip
              :activator="`#cam-id-${cam.id}`"
              top
              content-class="layoutIcons-tooltip"
            >
              <h1>{{ cam.name }}</h1>
            </v-tooltip>
          </div>
        </draggable>
      </section>

      <draggable
        class="layoutIcons-cams"
        :class="{
          ['layoutIcons-cams--text']: !displayThumbnail,
          ['layoutIcons-cams--video']: displayThumbnail,
        }"
        :list="initCams"
        group="layout-cams"
        handle=".icon-drag_drop"
        :move="handleMove"
        @end="handleDragEnd"
      >
        <div
          v-for="(cam, index) in initCams"
          :id="`cam-id-${cam.id}`"
          :key="index"
          class="layoutIcons-cam"
        >
          <video-stream
            v-if="displayThumbnail"
            :id="initCams[index].id"
            :ref="`display-cam-${index}`"
            :region="initCams[index].awsRegionName"
            :stream-config="{
              accessKeyId: iamKey,
              secretAccessKey: iamSecret,
              streamName: initCams[index].kvsVideoStreamName,
              region: initCams[index].awsRegionName,
              autoplay: true,
            }"
            :title="initCams[index].name"
            main
            :disable-zoom="true"
            zoomout-on-restore
            show-skeleton
            controller-size="small"
            :show-controllers="false"
            :hide-display-controller="true"
          />
          <h5>
            <span class="icon icon-drag_drop"></span>
            <span class="layoutIcons-cam_title">{{ cam.name }}</span>
          </h5>
          <v-tooltip
            :activator="`#cam-id-${cam.id}`"
            top
            content-class="layoutIcons-tooltip"
          >
            <h1>{{ cam.name }}</h1>
          </v-tooltip>
        </div>
      </draggable>
      <div class="layoutIcons-footer_gap"></div>
    </section>
  </main>
</template>

<script>
import draggable from 'vuedraggable';
import { mapState } from 'vuex';
import VideoStream from './VideoStream.vue';

export default {
  name: 'LayoutIcons',
  components: {
    draggable,
    VideoStream,
  },
  props: {
    contentHeight: {
      type: String,
      default: 'auto',
    },
    cams: {
      type: Array,
      required: true,
    },
    layers: {
      type: Array,
      required: true,
    },
    displayThumbnail: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      initCams: this.cams,
      initLayers: this.layers,
      movedTo: '',
      movedFrom: '',
      movingIndex: 0,
      futureIndex: 0,
    };
  },
  computed: {
    ...mapState({
      iamKey: (state) => state.common.iam.accessKeyId,
      iamSecret: (state) => state.common.iam.secretAccessKey,
    }),
  },
  watch: {
    initCams(value) {
      this.handleChange(value, 'cams');
    },
    initLayers(value) {
      this.handleChange(value, 'layers');
    },
  },
  mounted() {
    this.$emit('mounted');
  },
  methods: {
    handleChange(value, type) {
      this.$emit('change', { value, type });
    },
    handleDragEnd() {
      if (this.movedFrom === 'secondary' && this.movedTo === 'main') {
        // moved from secondary to main
        const draggedElementValue = this.initCams[this.movingIndex];
        const mainElementValue = this.initLayers[this.futureIndex];
        if (this.initLayers.length === 3) {
          this.$set(this.initCams, this.movingIndex, { ...mainElementValue });
          this.$set(this.initLayers, this.futureIndex, {
            ...draggedElementValue,
          });
        } else {
          this.initCams.splice(this.movingIndex, 1);
          this.initLayers.splice(this.futureIndex, 0, draggedElementValue);
        }
      } else if (this.movedFrom === 'main' && this.movedTo === 'secondary') {
        // moved from main to secondary
        const draggedElementValue = this.initLayers[this.movingIndex];
        const mainElementValue = this.initCams[this.futureIndex];
        this.$set(this.initCams, this.futureIndex, { ...draggedElementValue });
        this.$set(this.initLayers, this.movingIndex, {
          ...mainElementValue,
        });
      } else if (
        this.movedFrom === 'secondary' &&
        this.movedTo === 'secondary'
      ) {
        // moved from secondary to secondary
        const draggedElementValue = this.initCams[this.movingIndex];
        const secondaryElementValue = this.initCams[this.futureIndex];
        this.$set(this.initCams, this.movingIndex, {
          ...secondaryElementValue,
        });
        this.$set(this.initCams, this.futureIndex, { ...draggedElementValue });
      } else if (this.movedFrom === 'main' && this.movedTo === 'main') {
        // moved from main to main
        const draggedElementValue = this.initLayers[this.movingIndex];
        const mainElementValue = this.initLayers[this.futureIndex];
        this.$set(this.initLayers, this.movingIndex, { ...mainElementValue });
        this.$set(this.initLayers, this.futureIndex, {
          ...draggedElementValue,
        });
      }

      this.movedFrom = '';
      this.movedTo = '';
    },
    handleMove(e) {
      const { to, from, draggedContext } = e;
      if (to.className.indexOf('layoutIcons-layers') > -1) {
        this.movedTo = 'main';
      } else if (to.className.indexOf('layoutIcons-cams') > -1) {
        this.movedTo = 'secondary';
      } else {
        this.movedTo = '';
      }
      if (from.className.indexOf('layoutIcons-layers') > -1) {
        this.movedFrom = 'main';
      } else if (from.className.indexOf('layoutIcons-cams') > -1) {
        this.movedFrom = 'secondary';
      } else {
        this.movedFrom = '';
      }

      const { index, futureIndex } = draggedContext;
      this.movingIndex = index;
      this.futureIndex = futureIndex;
      return false;
    },
  },
};
</script>

<style lang="scss">
.layoutIcons {
  width: 495px;
  overflow-y: auto;
  min-height: 162px;
  margin: 41px 0 0;
  padding: 8px 0 0 60px;
  border: solid 1px #ccc;
  margin: 0 auto;
  background-color: #eeeeee;

  &-tooltip {
    &.v-tooltip__content {
      background-color: #4b4b4b;
    }
    &:after,
    &:before {
      top: 100%;
      left: 50%;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-top-color: #4b4b4b;
      border-width: 7px;
      margin-left: -7px;
    }
    &:before {
      border-color: rgba(108, 134, 206, 0);
      border-top-color: #4b4b4b;
      border-width: 8px;
      margin-left: -8px;
    }
    &.menuable__content__active {
      opacity: 1 !important;
    }
    h1 {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
    }
  }
  &-layout {
    width: 375px;
    margin: 9px 0 0;
    padding: 15px;
    border-radius: 5px;
    border: solid 1px #989898;
    background-color: #eee;
    position: sticky;
    top: 10px;
    z-index: 2;
    left: 0;
    &_title {
      width: 125px;
      height: 15px;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #666;
      background-color: #eee;
      position: absolute;
      top: -10px;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
  &-layers {
    display: grid;
    grid-template-columns: 165px 165px;
    grid-template-rows: 40px 40px;
    grid-auto-flow: column;
    column-gap: 15px;
    row-gap: 15px;
    &--text {
      .layoutIcons-layer {
        display: flex;
        align-items: center;
      }
    }
    &--video {
      grid-template-rows: 104px 104px;
      .layoutIcons-layer {
        padding-top: 4px;
        display: flex;
        align-items: center;
        flex-direction: column;
      }
    }
  }
  &-layer {
    border-radius: 5px;
    background-color: #fff;
    .videoStream {
      margin-bottom: 5px;
      video {
        width: 157px;
        height: 66px;
        object-fit: cover;
      }
    }

    &:first-child {
      grid-column: 1;
      grid-row: 1 / 3;
      .videoStream {
        margin-bottom: 5px;
        height: 187.6px;
        video {
          width: 157px;
          height: 182.6px;
        }
      }
    }
    &:not(:first-child) {
      .videoStream {
        height: 69px;
      }
    }
    &_title {
      width: 126px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }

    & > h5 {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .icon.icon-drag_drop {
        color: #989898;
        margin-right: 5px;
        cursor: move;
      }
    }
  }
  &-cams {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    padding-left: 15px;
    &--text {
      .layoutIcons-cam {
        display: flex;
        align-items: center;
      }
    }
    &--video {
      .layoutIcons-cam {
        height: 106px;
        padding: 4px;
        .videoStream {
          margin-bottom: 5px;
          height: 69px;
          video {
            width: 157px;
            height: 66px;
            object-fit: cover;
          }
        }
      }
    }
  }
  &-cam {
    width: 165px;
    height: 40px;
    border-radius: 5px;
    background-color: #fff;
    &:nth-child(odd) {
      margin-right: 15px;
    }
    margin-bottom: 15px;
    &_title {
      width: 126px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: var(--text-color);
    }

    & > h5 {
      display: flex;
      align-items: center;
      margin-left: 10px;
      .icon.icon-drag_drop {
        color: #989898;
        margin-right: 5px;
        cursor: move;
      }
    }
  }
  &-footer_gap {
    height: 76px;
  }
}
</style>
